import { useState, useEffect } from "react";
import SearchIcon from "assets/icons/fi-rr-search.svg";
import ExcelIcon from "assets/icons/xlsx-file-format-extension-1.svg";
import { DatePicker } from "antd";
import "moment/locale/tr";
import locale from "antd/es/date-picker/locale/tr_TR";
import "antd/dist/antd.css";
import * as XLSX from "xlsx";
import {DailyIndexModelResponse } from "types";
import axios from "axios";
import { useParams } from "react-router-dom";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import styles from "./style.module.scss";
import "./antd-picker.css";
import type { DatePickerProps } from "antd";
import ReactPaginate from "react-paginate";
import NextIcon from "assets/icons/pagination-next.svg";
import PrevIcon from "assets/icons/pagination-prev.svg";
import "../../../pages/sayacVerileri/paginate.css";
import LoaderSpinner from "../../UI/LoaderSpinner/LoaderSpinner";
import moment, { Moment } from "moment";
import { getEnvVars } from "env-cmd/dist/get-env-vars";
import { debug } from "console";
import { locationController } from "utils/locationhelper";
import AuthService from "../../../services/AuthService";
import { useKeycloak } from "@react-keycloak/web";

import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify'

const dateFormatTr = "DD.MM.YYYY";
const dateFormat = "YYYY-MM-DD";

const customFormat: DatePickerProps["format"] = (value) =>
  `${value.localeData().months(value)} ${value.year()} `;

const RangePickerChart = DatePicker.RangePicker;

const { RangePicker } = DatePicker;



const GunBazindaEndex = () => {
  const params = useParams<any>();

  const [showDetail, setShowDetail] = useState(false);
  const [windowWidth, setWindowWidth] = useState(0);
  const [monthValue, setMonthValue] = useState(0);
  const [dateRange, setDateRange] = useState<any[]>([]);
  const [yearValue, setYearValue] = useState(0);
  const [dailyIndexList, setDailyIndexList] = useState<DailyIndexModelResponse | []>(null!);
  const [pageCount, setPageCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(24);
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(24);

  const [showT0Cekis, setShowT0Cekis] = useState(true);
  const [showRiCekis, setShowRiCekis] = useState(true);
  const [showRcCekis, setShowRcCekis] = useState(false);
  const [showT0Veris, setShowT0Veris] = useState(true);
  const [showRiVeris, setShowRiVeris] = useState(false);
  const [showRcVeris, setShowRcVeris] = useState(false);

    
  const { keycloak } = useKeycloak();
  const auth = new AuthService(keycloak);

  let companyId = locationController();


  const getDailyIndex = async () => {
    setIsLoading(true);

    auth.axios(`/DailyIndex/GetDailyIndex`, null, {
      tesisatNo: params.id,
      companyId : companyId,
      pageSize: itemsPerPage,
      page: pageNumber,
      month: monthValue,
      year: yearValue 
    }).then((response) => {
        setIsLoading(false);
        if (response.data.success === true) {
          setDailyIndexList(response.data.data.itemList);
          setPageCount(Math.ceil(response.data.data.totalCount / itemsPerPage));
          setTotalCount(response.data.data.totalCount);
        } else {
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };


  useEffect(() => {
    if (yearValue !== 0 && monthValue !== 0) {
      getDailyIndex();
    }

  }, [pageNumber]);

 

  // Invoke when user click to request another page.
  const handlePageClick = (event: any) => {
    setPageNumber(event.selected + 1);
  };

  const handleExportCustonExcell = async() => {
    
    var response =  await auth.axios(`/DailyIndex/ExcelExport`, null, {
      tesisatNo: params.id,
      companyId : companyId,
      page: pageNumber,
      month: monthValue,
      year: yearValue,
      totalCount: totalCount
    });

    const base64Excel = "data:application/vnd.ms-excel;base64,"+ response.data.fileContents;

    const outputFilename = response.data.fileDownloadName;

    const link = document.createElement('a');
    link.download = outputFilename;
    link.href = base64Excel;
    document.body.appendChild(link);
    link.click();

  };
  return (
    <div>
      <ToastContainer/>
      <div className={styles.gunBazindaEndex}>
        <div className={styles.headerCard}>
          <div className={styles.cardSearch}>
            <div>Tarih</div>
            <div className={styles.rangePicker}>
              <DatePicker
                placeholder={"Tarih Seçiniz"}
                suffixIcon={false}
                locale={locale}
                bordered={false}
                format={customFormat}
                picker="month"
                onChange={(date: any) => {
                  setMonthValue(date?.month() + 1);
                  setYearValue(date?.year());
                }}
              />
            </div>
            <img
              onClick={() => {
                getDailyIndex();
              }}
              src={SearchIcon}
              alt=""
            />
          </div>
          <div
            onClick={() => {
              handleExportCustonExcell();
            }}
            className={styles.excel}
          >
            <img src={ExcelIcon} alt="" />
            <div>Excel'e aktar</div>
          </div>
        </div>

        <div className={styles.detailTable}>
          <div className={styles.tableHeader}>
            <div>Tarih</div>
    
            <div>Toplam Aktif</div>
            <div>T1 (Gündüz)</div>
            <div>T2 (Puant)</div>
            <div>T3 (Gece)</div>
            <div>Endüktif Reaktif Tüketim</div>
            <div>Kapasitif Reaktif Tüketim</div>
            <div>Demand Tüketim</div>
      
            <div>Toplam Üretim</div>
            <div>U1 (Gündüz)</div>
            <div>U2 (Puant)</div>
            <div>U3 (Gece)</div>
            <div>Endüktif Reaktif Üretim</div>
            <div>Kapasitif Reaktif Üretim</div>
            <div>Demand Üretim</div>
          </div>
          <div className={styles.hr}></div>
          {isLoading ? <LoaderSpinner /> : 
            dailyIndexList?.map((data, idx) => (
              <div key={idx}>
                <div className={styles.tableRow}>
                  <div>{data.tarih}</div>
                
                  <div>{data.toplamAktif}</div>
                  <div>{data.t1Gunduz}</div>
                  <div>{data.t2Puant}</div>
                  <div>{data.t3Gece}</div>
                  <div>{data.enduktifReaktifTuketim}</div>
                  <div>{data.kapasitifReaktifTuketim}</div>
                
                  <div>{data.demand}</div>
                  <div>{data.toplamUretim}</div>
                  <div>{data.u1Gunduz}</div>
                  <div>{data.u2Puant}</div>
                  <div>{data.u3Gece}</div>
                  <div>{data.enduktifReaktifUretim}</div>
                  <div>{data.kapasitifReaktifUretim}</div>
                  <div>{data.demandUretim}</div>
                </div>
                <div className={styles.hr}></div>
              </div>
            ))
            }
        </div>
        <div className="pagination-container">
          <ReactPaginate
            breakLabel="..."
            nextLabel={<img src={NextIcon} alt="icon" />}
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel={<img src={PrevIcon} alt="icon" />}
            className="pagination"
            activeClassName="pagination-active-item"
            containerClassName="pagination-container"
            pageClassName="pagination-item"
            previousClassName="pagination-item-previous"
            nextClassName="pagination-item-next"
            breakClassName="pagination-item-break"
          />
        </div>
  
      </div>
    </div>
  );
};

export default GunBazindaEndex;
